export default "__VITE_ASSET__C0l8ZmOr__"